// extracted by mini-css-extract-plugin
export default {"input":"AdminLogin_input__sivcQ","loginButton":"AdminLogin_loginButton__IlMtg"};